/**
 * Updates the recently viewed products in localStorage.
 */

/** @constant {string} The key used to store the viewed products in session storage */
const STORAGE_KEY = "viewedProducts";
/** @constant {number} The maximum number of products to store */
const MAX_PRODUCTS = 4;

/**
 * Adds a product to the recently viewed products list.
 * @param {string} productId - The ID of the product to add.
 */
export function addProduct(productId) {
	let viewedProducts = getProducts();

	viewedProducts = viewedProducts.filter(
		(/** @type {string} */ id) => id !== productId,
	);
	viewedProducts.unshift(productId);
	viewedProducts = viewedProducts.slice(0, MAX_PRODUCTS);

	localStorage.setItem(STORAGE_KEY, JSON.stringify(viewedProducts));
}

export function clearProducts() {
	localStorage.removeItem(STORAGE_KEY);
}

/**
 * Retrieves the list of recently viewed products from session storage.
 * @returns {string[]} The list of viewed products.
 */
export function getProducts() {
	return JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
}
